module.exports = __webpack_public_path__ + "static/img_0224_dpp_optimized-0ebcd9dcbb89e84b9404ca5a76307bfe.jpg";